import { useState } from 'react';

import { CustomAlert, Text } from '../../../../../shared/uiComponents';
import { PRIMARY } from '../../../../../shared/Helpers/colors';
import { Add, TargetIcon } from '../../../../../shared/Assets/sessionDetailsSVGs';
import { Close } from '../../../../../shared/Assets/svgIcons';
import TargetList from './targetList';

import { useSelector } from '../../../../../redux/store';
import { TargetSessionStatuses } from '../../../../../redux/API/ClientAPIHelpers/sessionsProperties';

const AddTargets = () => {
	const [open, setOpen] = useState<boolean>(false);

	const targets = useSelector((state) => state.session.targets);

	const targetsList = targets.filter((x) => x.targetStatus === TargetSessionStatuses.new);
	const hasActiveTargets = Boolean(
		targets.filter(
			(x) => x.targetStatus === TargetSessionStatuses.open || x.targetStatus === TargetSessionStatuses.active,
		).length,
	);

	const openTargetsHandler = () => setOpen(true);
	const closeTargetsHandler = () => setOpen(false);

	return (
		<>
			{targetsList && targetsList.length > 0 && (
				<div
					className="addTargetAction"
					onClick={openTargetsHandler}
					style={{ height: hasActiveTargets ? '88px' : '172px' }}
				>
					<div className="targetIcon">
						<Add color={PRIMARY.BASE} />
					</div>
					<Text title="Add Target" color={PRIMARY.BASE} type="plg" fontWeight="semiBold" />
				</div>
			)}
			{!targetsList.length && !hasActiveTargets && (
				<div className="addTargetAction" style={{ height: '88px' }}>
					<div className="targetIcon">
						<Close style={{ color: PRIMARY.BASE }} />
					</div>
					<Text title="No Targets" color={PRIMARY.BASE} type="plg" fontWeight="semiBold" />
				</div>
			)}
			<CustomAlert
				open={open}
				onClose={closeTargetsHandler}
				title="Select target"
				titleOnTop={false}
				Content={TargetList}
				Icon={TargetIcon}
			/>
		</>
	);
};

export default AddTargets;
